export default __webpack_public_path__ + "static/media/Bot-Login-2.4d8ba879.jpg";